import { FeatureFlagsJSON } from '../types';

export default class FeatureFlags {
	readonly id: number;

	private constructor( json: FeatureFlagsJSON ) {
		this.id = json.id;
	}

	static fromJson( json: FeatureFlagsJSON ): FeatureFlags {
		return new FeatureFlags( json );
	}
}
